import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

const stylesObject = css`
  outline: none;
  :focus {
    color: ${theme.colors.primary50};
  }
`;

export const DatePickerBaseFieldStyles = {
  buttonStyle: stylesObject,
};
